export type {
  Article as ArticleLDSchema,
  FAQPage as FAQPageLDSchema,
  Organization as OrganizationLDSchema,
  Person as PersonLDSchema,
  Product as ProductLDSchema,
  Thing as ThingLDSchema,
  WithContext as WithLDSchemaContext,
} from 'schema-dts';
export * from './components/StructuredData';
export { default as StructuredData } from './components/StructuredData';
